import { CheckboxField, DropdownField } from '@cian/components';
import * as React from 'react';
import { EMaxPrepay } from '../../../../../../../json_query';
import { InlineParam, InlineLabel } from '../../../markup';

export interface IRentTermsProps {
  commissionType: boolean;
  onComissionTypeChanged(value: number | undefined): void;

  maxPrepay: EMaxPrepay;
  onMaxPrepayChanged(value: EMaxPrepay): void;

  withoutDeposit: boolean;
  onWithoutDepositChanged(value: boolean): void;
}

export const RentTermsComponent: React.StatelessComponent<IRentTermsProps> = props => (
  <>
    <InlineLabel>предоплата</InlineLabel>
    <InlineParam>
      <DropdownField
        value={props.maxPrepay}
        onValueChange={props.onMaxPrepayChanged}
        values={[
          { value: EMaxPrepay.Any, label: 'любая' },
          { value: EMaxPrepay.Month, label: 'не более 1 месяца' },
          { value: EMaxPrepay.TwoMonths, label: 'не более 2х месяцев' },
          { value: EMaxPrepay.ThreeMonths, label: 'не более 3х месяцев' },
        ]}
      />
    </InlineParam>
    <InlineParam>
      <CheckboxField label="Без залога" value={props.withoutDeposit} onValueChange={props.onWithoutDepositChanged} />
    </InlineParam>
    <InlineParam>
      <CheckboxField
        label="Без комиссии"
        value={props.commissionType}
        onValueChange={value => props.onComissionTypeChanged(value ? 0 : undefined)}
      />
    </InlineParam>
  </>
);
